import handler from 'api/handler'

const prefix = '/userAdmin/meetings'

const methods = {
  create: args => handler({ method: 'post', url: prefix, args }),
  fetchAll: args => handler({ method: 'get', url: prefix, args }),
  fetchOne: id => handler({ method: 'get', url: `${prefix}/${id}` }),
  join: id => handler({ method: 'post', url: `${prefix}/${id}/join` }),
  update: (id, args) => handler({ method: 'patch', url: `${prefix}/${id}`, args }),
  cancel: id => handler({ method: 'post', url: `${prefix}/${id}/cancel` })
}

export default methods

